import React, { useEffect } from "react";
import { isAndroidWebview } from "utils/device.utils";
import "./App.css";
import Router from "./modules/router";

export const App: React.FC = () => {
  useEffect(() => {
    if(isAndroidWebview()) {
      window.location.href = `intent:${window.location.href}#Intent;end`
    }
  }, [])

  return (
    <div>
      <Router />
    </div>
  );
};
